import React, { useEffect, useState } from "react"
import { useDiensten } from "../../../hooks/useDiensten"
import Container from "../../atoms/Container"
import "./DienstenArchive.css"
import DienstCard from "../../atoms/Cards/DienstCard"

export default function DienstenArchive({ block }) {
  const data = useDiensten()
  const [filterItems, setFilterItems] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [activeFilter, setActiveFilter] = useState(null)

  useEffect(() => {
    const categoryMap = new Map()

    data.allWpDienst.edges.forEach(dienst => {
      dienst.node.categories.nodes.forEach(cat => {
        if (!categoryMap.has(cat.id)) {
          categoryMap.set(cat.id, cat)
        }
      })
    })

    const uniqueCategories = Array.from(categoryMap.values())

    setFilterItems(uniqueCategories)
    setFilteredData(data.allWpDienst.edges)
  }, [])

  const filterHandler = id => {
    const arr = data.allWpDienst.edges.filter(d =>
      d.node.categories.nodes.some(f => f.id == id)
    )
    setFilteredData(arr)
    setActiveFilter(id)
    console.log(arr)
  }

  const resetFilterHandler = () => {
    setFilteredData(data.allWpDienst.edges)
    setActiveFilter(null)
  }

  console.log(filterItems)

  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-diensten-archive">
        <h2>{block.titel}</h2>
        <div className="vt-diensten-archive-buttons">
          <div
            className={`${
              activeFilter == null ? "vt-button-active" : ""
            } vt-diensten-archive-button`}
            onClick={resetFilterHandler}
          >
            Alle diensten
          </div>
          {filterItems.map(f => {
            return (
              <div
                className={`${
                  activeFilter == f.id ? "vt-button-active" : ""
                } vt-diensten-archive-button`}
                onClick={() => {
                  filterHandler(f.id)
                }}
              >
                {f.name}
              </div>
            )
          })}
        </div>
        <div className="vt-diensten-archive-grid">
          {filteredData.map(dienst => {
            return <DienstCard data={dienst.node} />
          })}
        </div>
        <div className="vt-whitespace-container"></div>
      </div>
    </Container>
  )
}
